import { Component, DestroyRef, inject, Input } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EditorInitEvent, EditorModule } from 'primeng/editor';
import { TooltipModule } from 'primeng/tooltip';
import { ValueAccessorDirective } from '../../directives/value-accessor.directive';

const FORMATS = ['header', 'bold', 'italic', 'underline', 'list'];
const DEFAULT_STYLE = { height: '220px' };

@Component({
  selector: 'pa-editor',
  standalone: true,
  imports: [EditorModule, FormsModule, ReactiveFormsModule, TooltipModule],
  templateUrl: './pa-editor.component.html',
  styleUrls: ['./pa-editor.component.scss'],
  hostDirectives: [ValueAccessorDirective],
})
export class PaEditorComponent {
  @Input() label: string = undefined;
  @Input() placeholder: string = '';
  @Input() tooltip: string = null;
  @Input() hint: string = undefined;
  @Input() editorStyle: Record<string, string> = DEFAULT_STYLE;

  readonly valueAccessor = inject(ValueAccessorDirective<string | null>);
  readonly formats = FORMATS;

  private readonly destroyRef = inject(DestroyRef);

  handleEditorInit({ editor }: EditorInitEvent): void {
    const toolbar = editor.getModule('toolbar');
    const onMousedown = (event: MouseEvent): void => {
      event.preventDefault();
    };

    toolbar.container.addEventListener('mousedown', onMousedown);
    this.destroyRef.onDestroy(() => {
      toolbar.container.removeEventListener('mousedown', onMousedown);
    });

    toolbar.addHandler('list', function (value) {
      const range = this.quill.getSelection(true);
      if (!range) {
        return;
      }

      const { list } = this.quill.getFormat(range);
      if (value === false || list === value) {
        this.quill.format('list', false, 'user');
        return;
      }

      this.quill.format('list', value, 'user');
    });
  }
}
